function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

export interface TabsProps {
  tabs: {
    name: string;
    href: string;
    current: boolean;
    testId?: string;
  }[];
  /** The user picked a tab (from the tab bar or the mobile select). */
  onTabSelect?: (tabName: string) => void;
}

export default function Tabs(props: TabsProps) {
  const { tabs, onTabSelect } = props;
  return (
    <div>
      <div className="grid grid-cols-1 sm:hidden">
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          value={tabs.find((tab) => tab.current)?.href}
          aria-label="Select a tab"
          className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 my-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 border-0 focus:ring-0"
          onChange={(e) => {
            const selectedHash = e.currentTarget.value;
            const selectedTab = tabs.find((tab) => tab.href === selectedHash);
            if (selectedTab) onTabSelect?.(selectedTab.name);
            if (window) {
              window.location.hash = selectedHash;
            }
          }}
        >
          {tabs.map((tab) => (
            <option key={tab.href} value={tab.href}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                onClick={() => {
                  if (!tab.current) onTabSelect?.(tab.name);
                }}
                aria-current={tab.current ? "page" : undefined}
                className={classNames(
                  tab.current
                    ? "border-lf-blue-light-3 text-lf-blue-3"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                  "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium",
                )}
                data-testid={tab.testId ? `${tab.testId}-tab` : ""}
              >
                {tab.name}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
